import script from "./textdialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./textdialog.vue?vue&type=script&lang=ts&setup=true"

import "./textdialog.vue?vue&type=style&index=0&id=2d3b01cc&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3b01cc"]])

export default __exports__